import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./_css/featureOptions.module.css";
import clsx from "clsx";
import { useUnitStore } from "units/UnitContext";

export function UnitFeatures() {
    const { t } = useTranslation();
    const { unit } = useUnitStore();
    if (!unit.features) return null;
    return (
        <div className={clsx(styles.list, "mt_20 flex_row")}>
            {unit.features && (
                <div className="flex-1">
                    <h2 className={styles.title}>{t("unit.featuresTitle")}</h2>
                    <ul className={"flex_column"}>
                        {Object.keys(unit.features).map((feature) => {
                            if (!unit.features[feature]) return null;
                            return <li key={feature}>{t(`unit.features.${feature}`)}</li>;
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}
